import { useQuery } from 'react-query'

import { useAuthedFetch } from '../auth/useAuthedFetch'
import withFetchCancel from '../libs/withFetchCancel'
import { PRINT_POSITION_TYPES } from '../AppProviders/PrinterProvider'

const BACKEND_ENDPOINT = process.env.REACT_APP_BACKEND_ENDPOINT

export const useFetchShippingLabels = () => {
  const authedFetch = useAuthedFetch()
  return (shippingCodes, modelType, printPosition = 0) =>
    authedFetch(
      'POST',
      `${BACKEND_ENDPOINT}/shippings/rpc-multiple-shipping-labels`,
      {
        parseJSON: true,
        data: {
          shipping_codes: shippingCodes,
          model_type_code: modelType,
          label_type_code: 'PDF',
          label_offset: printPosition,
        },
      },
    ).then(({ data }) => {
      const labelData = data.data[0] ?? {}
      return labelData
    })
}

export const useShippingsLabels = (
  shippingCodes,
  modelType,
  printPosition = 0,
  onSuccessCallback,
) => {
  const authedFetch = useAuthedFetch()
  const query = useQuery(
    ['shippingsLabels', shippingCodes],
    () =>
      withFetchCancel(signal =>
        authedFetch(
          'POST',
          `${BACKEND_ENDPOINT}/shippings/rpc-multiple-shipping-labels`,
          {
            parseJSON: true,
            signal,
            data: {
              shipping_codes: shippingCodes,
              model_type_code: modelType,
              label_type_code: 'PDF',
              label_offset:
                printPosition === PRINT_POSITION_TYPES.askAlways
                  ? 0
                  : printPosition,
            },
          },
        ),
      ),
    {
      enabled: shippingCodes?.length !== 0,
      onSuccess: data => {
        const labelData = data.data.data[0] ?? {}
        onSuccessCallback(labelData)
      },
      // onError: ??
    },
  )

  return query
}
